import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'

import {PfReduxState} from 'src/reducers/types'
import {PfDispatch} from 'src/store/types'

export const usePfDispatch = (): PfDispatch => useDispatch<PfDispatch>()

export const usePfSelector: TypedUseSelectorHook<PfReduxState> = useSelector
